import { FC } from 'react';
import { removeAllBrackertsFromString } from '@/helpers/helpers';
import { IBookShortDetail } from '@/interfaces/bookShortDetail.interface';

interface IBookRatingJsonMarkupProps {
  book: IBookShortDetail;
  authorFullName: string;
}

const BookRatingJsonMarkup: FC<IBookRatingJsonMarkupProps> = ({ book, authorFullName }) => {
  const genreItems = book.genres.map((genre) => genre.title[0].toUpperCase() + genre.title.slice(1));
  const genresString = genreItems.join(' ');
  const description = removeAllBrackertsFromString(`${book.book.description}`);

  const getBookJsonMarkup = () => {
    return {
      __html: `{
        "@context":"https://schema.org/",
        "@type":"Book",
        "image":"https://fenzin.org/covers/${book.book.external_id}.jpg",
        "name":"${book.book.title}",
        "description":"${description}",
        "genre":"${genresString}",
        "inLanguage":"${book.book.lang}",
        "author":{"@type":"Thing","name":"${authorFullName}"},
        "aggregateRating":{
          "@type":"AggregateRating",
          "ratingValue":"${book.rating}",
          "ratingCount":"${book.voted_users}",
          "bestRating":"5",
          "worstRating":"1"
        }
      }`,
    };
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={getBookJsonMarkup()} key="product-jsonld" />;
};

export default BookRatingJsonMarkup;
